import { Button, Col, Modal, Row } from 'antd';
import React, { Component } from 'react';
import ReactToPrint from 'react-to-print';
import '../App.css';
//import locationMarker from "../img/locationMarker.svg";
import subjectIcon from '../img/covid19/subject_icon.svg';
import '../style/card.css';
import '../style/flipCard.css';

import moment from 'moment';

class Card extends Component {
  constructor(props) {
    super(props);

    // console.log(this.props.project["PARCEIROS"]);

    this.state = {
      modal1Visible: false,
      modal2Visible: false
    };
  }

  setModal2Visible(modal2Visible) {
    this.setState({ modal2Visible });
  }

  renderColorDependingOnTEMA(tematica) {
    let color;
    // "Saúde",
    // "Participação",
    // "Apoio Social"
    switch (tematica && tematica[0] ? tematica[0] : tematica) {
      case 'Saúde':
        color = '#ea728c';
        break;
      case 'Participaçao':
        color = '#fc9d9d';
        break;
      case 'Cultura':
        color = '#f3d4d4';
        break;
      case 'Emprego':
        color = '#c70039';
        break;
      // case "Reabilitação e Requalificação de Espaços":
      //   color = "#fdba9a";
      //   break;
      default:
        color = '#f77475';
        break;
    }

    return color;
  }

  componentDidMount() {}
  render() {
    const isUpdated = (updatedAt) => moment(updatedAt).isAfter('2021-5-16');
    return (
      <div style={{ margin: 5 }}>
        <div
          className="flip-container "
          // onTouchStart="this.classList.toggle('hover');"
        >
          <div className="flipper">
            <div
              className="front cardFront"
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                background: this.renderColorDependingOnTEMA(
                  this.props.project['áreas temáticas']
                ),
                border: isUpdated(this.props.project.updatedAt)
                  ? '5px solid #C3DBC5'
                  : null
              }}
            >
              {/* FRONT */}
              {isUpdated(this.props.project.updatedAt) ? (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: 80,
                    height: 20,
                    backgroundColor: '#C3DBC5',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: 10,
                    borderBottomLeftRadius: 10
                  }}
                >
                  Atualizado
                </div>
              ) : null}
              <div
                className="cardTitle"
                style={{
                  padding: 10,
                  zIndex: 100,
                  // height: "auto",
                  width: '100%',
                  maxHeight: 35,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                  // display: "-webkit-box",
                  // WebkitLineClamp: 1,
                  // WebkitBoxOrient: "vertical",
                }}
              >
                {this.props.title}
              </div>

              {this.props.selectedResposta &&
              this.props.selectedResposta !== 'TODOS' ? (
                <div
                  style={{
                    background: '#fff9',
                    margin: 1,
                    // height: 20,
                    justifySelf: 'start',
                    align: 'top',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    paddingLeft: '5px',
                    borderRadius: '3px'
                  }}
                >
                  <div
                    style={{
                      fontFamily: 'Work Sans',
                      fontSize: '10px',
                      color: '#000000',
                      textTransform: 'uppercase',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      WebkitLineClamp: 2 /* number of lines to show */,
                      WebkitBoxOrient: 'vertical'
                    }}
                  >
                    {this.props.selectedResposta}
                  </div>
                </div>
              ) : null}

              {this.props.project['Respostas COVID'] &&
                this.props.project['Respostas COVID']
                  .slice(0, 4) //max RESPOSTAS on card
                  .map((resposta) =>
                    resposta !== this.props.selectedResposta ? ( //above we have the selected RESPOSTA and now we need all other (not repeating the showd above)
                      <div
                        key={resposta}
                        style={{
                          background: '#fff2',
                          margin: 1,
                          //height: 20,
                          // justifySelf: "start",
                          // align: "top",
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',

                          display: 'flex',
                          flexDirection: 'column',
                          // alignItems: "center",
                          justifyContent: 'center',
                          borderRadius: '3px',
                          paddingLeft: '5px',
                          maxHeight: '27px'
                          // padding: "2px",
                        }}
                      >
                        <div
                          style={{
                            width: '100%',
                            fontFamily: 'Work Sans',

                            fontSize: '10px',
                            //padding: "5px",
                            color: '#000000',
                            textTransform: 'uppercase',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical'

                            // alignSelf: "flex-center",
                          }}
                        >
                          {resposta}
                        </div>
                      </div>
                    ) : null
                  )}

              <div
                //className="iconNLocal"
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  width: '177px',
                  color: '#000'
                }}
              >
                <img className="locIcon" src={subjectIcon} alt="loc" />
                <div
                  className="cardDescript"
                  style={{
                    maxLines: 1,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',

                    maxHeight: 30,
                    display: '-webkit-box',
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: 'vertical'
                  }}
                >
                  {this.props.project['áreas temáticas'] &&
                    this.props.project['áreas temáticas'].map(
                      (area) => area + '. '
                    )}
                </div>
              </div>
            </div>
            <div className="back cardBack">
              {/* BACK */}
              <div
                className="backProjectYear"
                style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                <div>
                  <strong>BipZip:</strong>
                </div>
                <br />
                {this.props.project['nomeBairroBipZip'] &&
                  this.props.project['nomeBairroBipZip'].map((bairro) => (
                    <div key={bairro}>#{bairro}</div>
                  ))}
              </div>
              {/* <div className="backDescript">
                {this.props.project["TEMÁTICA"]}
              </div>
              <div className="backDescript" style={{ justify: "end" }}>
                {this.props.project["TEMÁTICA APROFUNDADA"]}
              </div>*/}

              <Button
                style={{ align: 'bottom', justifySelf: 'start', width: '90px' }}
                type="primary"
                onClick={() => this.setModal2Visible(true)}
              >
                Ver Ficha
              </Button>
              <Modal
                destroyOnClose={true}
                closable={true}
                cancelButtonProps={{ visible: false }}
                title={'Ficha de Projecto'}
                wrapClassName="vertical-center-modal"
                visible={this.state.modal2Visible}
                okText="Fechar"
                //onOk={() => this.setModal2Visible(false)}
                onCancel={() => this.setModal2Visible(false)}
                footer={[
                  <Button key="ok" onClick={() => this.setModal2Visible(false)}>
                    Fechar
                  </Button>
                ]}
                //cancelText={"Imprimir"}
                //onCancel={() => window.print()}
                width="90%"
                // ref={(el) => (this.componentToPrint = el)}
              >
                <Row type="flex" justify="space-between" align="left">
                  <Col offset={2} xs={{ span: 20 }} lg={{ span: 4 }}>
                    <div className="yearOnModal">
                      {this.props.project['ANO']}
                    </div>
                  </Col>
                </Row>

                <Row type="flex" justify="space-around" align="middle">
                  <Col xs={{ span: 20 }} lg={{ span: 20 }}>
                    <br />
                    <div className="titleModal paddingBottom30">
                      {this.props.project['Quem sou']}
                    </div>

                    <div className="ModalPromotorTitle">Entidades</div>
                    {this.props.project['Nome entidades'] &&
                      this.props.project['Nome entidades'].map(
                        (parceiro, idx) => (
                          <div key={idx} className="tagProjecto tagsText">
                            {parceiro}
                          </div>
                        )
                      )}
                    <div className="subSubTitles">FREGUESIAS</div>
                    {this.props.project['FREGUESIA'] &&
                      this.props.project['FREGUESIA'].map((freg, idx) => (
                        <div key={idx} className="tagProjectoAzul">
                          {freg}
                        </div>
                      ))}
                    <br />
                    <div className="subSubTitles">BIP/ZIP</div>

                    <div>
                      {this.props.project['nomeBairroBipZip'] &&
                        this.props.project['nomeBairroBipZip'].map(
                          (bz, idx) => (
                            <div key={idx} className="tagProjectoAzul">
                              {bz}
                            </div>
                          )
                        )}
                    </div>
                    <div className="ModalPromotorTitle">Descrição:</div>
                    <div className="descriptionTextModal paddingBottom30">
                      <div style={{ marginTop: 20 }}>
                        {this.props.project['descrição proposta']}
                      </div>

                      {/* {this.props.project['descrição proposta'].map(
                        (descricao, idx) => (
                          <div style={{ marginTop: 20 }}> • {descricao}</div>
                        )
                      )} */}
                    </div>
                    {/* <div className="ModalPromotorTitle">Como:</div>
                    <div
                      className="paddingBottom30"
                      style={{
                        fontFamily: 'Work Sans',
                        lineHeight: '30px',
                        fontSize: '16px',
                        color: '#000000'
                      }}
                    >
                      {this.props.project['descrição proposta__1'] &&
                        this.props.project[
                          'descrição proposta__1'
                        ].map((descricao, idx) => (
                          <div style={{ marginTop: 20 }}> • {descricao}</div>
                        ))}
                    </div> */}
                    <div className="ModalPromotorTitle">
                      Objectivo e Relevância:
                    </div>
                    <div
                      className="paddingBottom30"
                      style={{
                        fontFamily: 'Work Sans',
                        lineHeight: '30px',
                        fontSize: '16px',
                        color: '#000000'
                      }}
                    >
                      {this.props.project['objectivo e relevância'] && (
                        <div
                          style={{
                            marginTop: 20,
                            textTransform: 'capitalize'
                          }}
                        >
                          • {this.props.project['objectivo e relevância']}
                        </div>
                      )}
                    </div>
                    {/* <div className="ModalPromotorTitle">Info Útil:</div>
                    <div
                      className="paddingBottom30"
                      style={{
                        fontFamily: 'Work Sans',
                        lineHeight: '30px',
                        fontSize: '16px',
                        color: '#000000'
                      }}
                    >
                      {this.props.project['info útil'] &&
                        this.props.project['info útil'].map(
                          (descricao, idx) => (
                            <div
                              style={{
                                marginTop: 20,
                                textTransform: 'capitalize'
                              }}
                            >
                              • {descricao}
                            </div>
                          )
                        )}
                    </div> */}

                    <div className="ModalPromotorTitle">Responsável</div>
                    <div
                      key={'name'}
                      className="tagProjectoAzul"
                      style={{ textTransform: 'uppercase' }}
                    >
                      {this.props.project['Nome contacto']}
                    </div>
                    <div className="ModalPromotorTitle">Email</div>
                    <div
                      key={'email'}
                      className="tagProjectoAzul"
                      style={{ textTransform: 'lowercase' }}
                    >
                      {this.props.project['Email contacto']}
                    </div>

                    {/* <div className="ModalPromotorTitle">Morada</div>
                    <div
                      key={'morada'}
                      className="tagProjectoAzul"
                      style={{ textTransform: 'capitalize' }}
                    >
                      {this.props.project['morada entidade']}
                    </div> */}

                    <div className="ModalPromotorTitle">Áreas temáticas</div>
                    {this.props.project['áreas temáticas'] &&
                      this.props.project['áreas temáticas'].map((tema, idx) => (
                        <div key={idx} className="tagProjecto tagsText">
                          {tema}
                        </div>
                      ))}
                    <br />

                    <div className="ModalPromotorTitle">Respostas COVID</div>
                    {this.props.project['Respostas COVID'] &&
                      this.props.project['Respostas COVID'].map(
                        (resposta, idx) => (
                          <div key={idx} className="tagProjectoAzul">
                            {resposta}
                          </div>
                        )
                      )}
                    <br />
                    <div className="ModalPromotorTitle">Acções Covid</div>
                    {this.props.project['lista acções'] &&
                      this.props.project['lista acções'].map((accoes, idx) => (
                        <div key={idx} className="tagProjecto tagsText">
                          {accoes}
                        </div>
                      ))}
                    <br />
                    {/* 
                    <div className="ModalPromotorTitle">#RESPOSTAS/ACÇÕES</div>
                    {this.props.project['Respostas COVID'] &&
                      this.props.project['Respostas COVID'].map(
                        (resposta, idx) => (
                          <div>
                            <div
                              key={idx}
                              className="tagProjectoAzul"
                              style={{ textTransform: 'uppercase' }}
                            >
                              #{resposta}
                            </div>
                            <br />

                            {this.props.project['lista acções'].forEach(
                              (accaoToShow, idx) => {
                                let accaoBelongsToResposta = relacaoRespostasAccoes.lista_de_acções.find(
                                  (accao) =>
                                    accao['Respostas Covid'] === resposta &&
                                    accaoToShow === accao.Acção
                                );

                                if (accaoBelongsToResposta) {
                                  return (
                                    <div
                                      key={idx}
                                      className="tagProjecto tagsText"
                                      style={{ textTransform: 'capitalize' }}
                                    >
                                      {accaoToShow}
                                    </div>
                                  );
                                }
                              }
                            )}
                          </div>
                        )
                      )}
                    <br /> */}

                    <div className="ModalPromotorTitle">
                      Recursos disponiveis:
                    </div>
                    {this.props.project['DISPONIBILIZO']
                      ? this.props.project['DISPONIBILIZO'].map(
                          (recurs, idx) => (
                            <div key={idx} className="tagProjectoAzul">
                              {recurs}
                            </div>
                          )
                        )
                      : null}
                    <div className="subSubTitles">
                      Descrição de recursos disponiveis
                    </div>
                    <div
                      className="paddingBottom30"
                      style={{
                        fontFamily: 'Work Sans',
                        lineHeight: '30px',
                        fontSize: '16px',
                        color: '#000000'
                      }}
                    >
                      {this.props.project['descrição recursos disponiveis']}
                    </div>

                    <br />
                    <div className="ModalPromotorTitle">
                      Recursos necessários:
                    </div>
                    {this.props.project['NECESSITO'] &&
                      this.props.project['NECESSITO'].map((recurs, idx) => (
                        <div key={idx} className="tagProjectoAzul">
                          {recurs}
                        </div>
                      ))}
                    <div className="subSubTitles">
                      Descrição de recursos necessários
                    </div>
                    <div
                      className="paddingBottom30"
                      style={{
                        fontFamily: 'Work Sans',
                        lineHeight: '30px',
                        fontSize: '16px',
                        color: '#000000'
                      }}
                    >
                      {this.props.project['descrição recursos necessita']}
                    </div>
                    <br />

                    {/* <div className="ModalPromotorTitle">
                      Como Podemos Ajudar?
                    </div>
                    <div
                      className="paddingBottom30"
                      style={{
                        fontFamily: 'Work Sans',
                        lineHeight: '30px',
                        fontSize: '16px',
                        color: '#000000'
                      }}
                    >
                      {this.props.project['Fonte da Informação'] &&
                      this.props.project['Fonte da Informação'].lenght > 0
                        ? this.props.project[
                            'Fonte da Informação'
                          ].map((descricao, idx) => (
                            <div style={{ marginTop: 20 }}> • {descricao}</div>
                          ))
                        : 'Sem Informação'}
                    </div>
                    <div className="ModalPromotorTitle">
                      Fonte da Informação
                    </div>
                    <div
                      className="paddingBottom30"
                      style={{
                        fontFamily: 'Work Sans',
                        lineHeight: '30px',
                        fontSize: '16px',
                        color: '#000000'
                      }}
                    >
                      {this.props.project['Como Podemos Ajudar'] &&
                      this.props.project['Como Podemos Ajudar'].lenght > 0
                        ? this.props.project[
                            'Como Podemos Ajudar'
                          ].map((descricao, idx) => (
                            <div style={{ marginTop: 20 }}> • {descricao}</div>
                          ))
                        : 'Sem Informação'}
                    </div> */}
                  </Col>
                  <Col xs={{ span: 20 }} lg={{ span: 20 }}>
                    <ReactToPrint
                      style={{ alignSelf: 'right' }}
                      trigger={() => (
                        <Button
                          style={{
                            align: 'bottom',
                            justifySelf: 'start',
                            width: '90px',
                            marginTop: '30px'
                          }}
                          type="primary"
                        >
                          Imprimir
                        </Button>
                      )}
                      content={() => this.componentToPrint}
                    />
                  </Col>
                </Row>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Card;
